import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { BrowserService } from './../../../shared/service/browser/browser.service';

@Injectable()
export class GridNavService {
    _formation: string;
    layout = new Subject<string>();
    layout$ = this.layout;

    constructor(private browserService: BrowserService) {
        this.layout$.subscribe(layout => this.formation = layout);
    }

    get formation(): string {
        if (this.hasLocalStorage && this.browserService.isBrowser) {
            return localStorage.getItem('sg-layout');
        }

        return this._formation;
    }

    set formation(data) {
        if (this.hasLocalStorage && this.browserService.isBrowser) {
            localStorage.setItem('sg-layout', data);
        }

        this._formation = data;
    }

    hasLocalStorage(): boolean {
       const hasLocalStorage = 'localStorage' in window && window['localStorage'] !== null;

       return !!hasLocalStorage;
    }
}
